import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { existToken } from "../redux/slices/auth/authAction";

export const useVerificateToken = (privateRoute = false) => {
	const state = useSelector((state) => state.auth.authentication);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const verificateNavigate = useCallback(() => {
		if (privateRoute) {
			dispatch(existToken(navigate, privateRoute));
		} else {
			dispatch(existToken(navigate, privateRoute));
		}
	}, [dispatch, navigate, privateRoute]);

	useEffect(() => {
		if (!state) {
			verificateNavigate();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [state]);
	return "Verificar token";
};
